import { render, staticRenderFns } from "./ControleUsuario.vue?vue&type=template&id=883341c0&"
import script from "./ControleUsuario.vue?vue&type=script&lang=js&"
export * from "./ControleUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports